import GSOParasite from '../Game/Base/GSOParasite';
import ClickVoid from '../GameKit/LevelEditor/ClickVoid';
import Vector from '../Game/Base/Math/Vector';
import Global from '../Game/Global';

export default class TouchControlsOverlay extends GSOParasite {
    constructor(realParent, stepParent) {
        super(realParent, stepParent);

        this.touchInputCanvas = new ClickVoid(this);
        this.touchInputCanvas.onMouseMove = position => {
            const game = this.getAttachedStepParent();
            if (game.activeLevel && game.activeLevel.player.physicsBody) {
                position = game.canvasToGamePosition(position);
                let playerPos = Vector.fromPlanckVec2(game.activeLevel.player.physicsBody.getPosition()).mul(new Vector(Global.PHYSICS_SCALE));
                playerPos = position.sub(playerPos);
                playerPos.divm(new Vector(100));
                if (playerPos.length() > 1.0) {
                    playerPos.normalize();
                }
                game.inputVector = playerPos;
            }
        };
        this.touchInputCanvas.onMouseUp = () => {
            const game = this.getAttachedStepParent();
            game.inputVector = new Vector(0);
        };
    }
}
